var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeEmail = function SvgCassiopeiaBadgeEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.2,
    height: 47.3,
    viewBox: "0 0 39.2 47.3",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.2,25.5h0l-10.2-6.3h0v15.5l10.5-9c-.2-.1-.3-.2-.3-.2h0Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,27.1h-.8c-1.5,0-2.8-.3-3.9-.6l-11,9.4h30l-4.3-3.8h0c0,.1-2-.6-2-.6v-.2c-3.2-.2-6.1-1.9-7.9-4.3h0s-.1.1-.1.1Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2,34.5v-5.5c-1.2.9-2.5,1.7-3.9,2.1l3.9,3.5h0Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,13.9c-.6,0-1.1.5-1.1,1.1v1.8l11.2,6.9c.2,0,2.3,1.2,5,1.4-.4-.9-.7-1.9-.9-3h-.2v-2h0c0-2.3.8-4.4,2.1-6.2H3.1Z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7,12.9c1.1.3,1.9,1.1,2.4,2.1.9,1.8,0,3.8-2,4.9,0,.1-.2.1-.4.2h5.4c-.2-5.5-4.4-10-9.8-10.6v5.5c.9-1.5,2.4-2.7,4.4-2.1Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8,24.3c.5.2.7.8.5,1.3-.2.4-.5.6-.9.6s-3.2-1.9-3.9-2.7v8.7l4.3,3.8H3.7l11-9.4c1.1.3,2.4.6,3.9.6h.8c1.9,2.4,4.7,4.1,7.9,4.3v-7.9c-.7.8-1.8,1.8-3.5,2.6-.1,0-.3.1-.4.1-.4,0-.7-.2-.9-.6-.2-.5,0-1.1.5-1.3,1.5-.7,2.4-1.6,2.9-2.2h-8.6c.2,1,.4,2,.9,3-2.7-.1-4.8-1.3-5-1.4l-11.2-7v-1.8c0-.6.5-1.1,1.1-1.1h16.2c-1.3,1.8-2.1,3.9-2.1,6.2h5.8c-.1,0-.3-.1-.4-.2-2-1.2-2.8-3.1-2-4.9.5-1,1.3-1.7,2.4-2.1,2-.6,3.5.7,4.4,2.1v-5.5c-2.3.2-4.4,1-6.1,2.4H3.1c-1.7,0-3.1,1.4-3.1,3.1v19.8c0,1.7,1.4,3.1,3.1,3.1h30.9c1.7,0,3.1-1.4,3.1-3.1v-8.1c.6-.9,1.2-2.1,1.6-3.6,0-.3.2-.6.2-.9h-8.2c.5.6,3.1,2.1,3.1,2.1ZM2,34.6v-15.5h0l10.1,6.3h0s.1,0,.3.2l-10.4,9.1h0ZM35.2,34.5l-3.9-3.5c1.4-.4,2.8-1.1,3.9-2.1v5.6Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3,15.7c-.2-.4-.5-.9-1.2-.9h-.4c-1,0-1.8,1.4-1.9,1.8-.2.6-.5,1.6-.6,2.5.9-.1,2-.4,2.9-.9.3-.2,1.6-1,1.3-2.2,0,0,0-.2,0-.3Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2,22.1v-1.7s0,.8-.2,1.7h.2Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4,32.3h0c0-.1-.8-.8-.8-.8h-1.2v.2l2,.7h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2,22.1h.2c0-.5-.1-1.1-.1-1.7s0-.2,0-.4h0v2s-.1.1-.1,0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,15.9c-.3,1.2,1,2,1.3,2.2.9.5,2,.8,2.9.9-.1-.9-.4-1.9-.6-2.5-.1-.4-.9-1.8-1.9-1.8h-.4c-.7,0-1.1.5-1.2.9s0,.3,0,.3Z",
    style: {
      fill: "#55c81e",
      strokeWidth: 0
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-email.a331482906eff39936c97dc6e127cee0.svg";